import CallEventsService from '@/services/CallEventsService';
import { CALL_EVENT_EVENT_SUB_TYPES, CALL_EVENT_TYPES } from '@/util/callActionsAndEvents';

export default {
  namespaced: true,
  state: {
    name: '', // name of current caller
    participantName: '', // name of caller on other end
    visitId: null,
    chatbox: {
      open: false,
      messages: [],
      unread: false,
    },
    hand: {
      raised: false,
    },
  },
  getters: {},
  mutations: {
    SET_CHATBOX_OPEN(state, value) {
      state.chatbox.open = value;

      if (value) {
        state.chatbox.unread = false;
      }
    },
    ADD_MESSAGE(state, message) {
      state.chatbox.messages.push(message);
    },
    SET_CHATBOX_MESSAGES(state, messages) {
      state.chatbox.messages = messages;
    },
    SET_HAND_PROP(state, item) {
      state.hand[item.prop] = item.value;
    },
    SET_HAND_RAISED(state, value) {
      state.hand.raised = value;
    },
    SET_CHATBOX_UNREAD(state, value) {
      state.chatbox.unread = value;
    },
    SET_VISIT_ID(state, item) {
      state.visitId = item;
    },
    SET_NAME(state, item) {
      state.name = item;
    },
    SET_PARTICIPANT_NAME(state, item) {
      state.participantName = item;
    },
  },
  actions: {
    addMessage({ commit, dispatch, state }, message) {
      commit('ADD_MESSAGE', message);
      dispatch('createCallEvent', {
        visit_id: state.visitId,
        type: CALL_EVENT_TYPES.EVENT,
        sub_type: CALL_EVENT_EVENT_SUB_TYPES.NEW_CHAT_MESSAGE,
        meta: message,
      })
    },
    addParticipantMessage({ state, commit }, message) {
      commit('ADD_MESSAGE', message);
      if (!state.chatbox.open) {
        commit('SET_CHATBOX_UNREAD', true);
      }
    },
    acknowledgeHandRaised({ state, dispatch, commit }) {
      commit('SET_HAND_RAISED', false); // todo only do this on success

      return dispatch('createCallEvent', {
        visit_id: state.visitId,
        type: CALL_EVENT_TYPES.EVENT,
        sub_type: CALL_EVENT_EVENT_SUB_TYPES.HAND_RAISE_ACKNOWLEDGED,
      })
    },
    // eslint-disable-next-line no-unused-vars
    createCallEvent({ state }, dto) {
      return CallEventsService.createGeneralEvent(dto).then(res => {
        console.log('call event created', res.data);
      }).catch(err => {
        console.log('could not send call event', err.response);
      });
    },
    setUpVisit({ commit, dispatch }, visit) {
      // eslint-disable-next-line no-underscore-dangle
      commit('SET_VISIT_ID', visit._id);
      commit('SET_NAME', `${visit.visitor.firstname} ${visit.visitor.lastname}`);
      commit('SET_PARTICIPANT_NAME', `${visit.prisoner.firstname} ${visit.prisoner.lastname}`);
      dispatch('getChatMessages');
    },
    getChatMessages({ state, commit }) {
      return CallEventsService.getChatMessages(state.visitId).then(res => {
        const messages = [];
        res.data.forEach(item => {
          messages.push(item.meta);
        })
        commit('SET_CHATBOX_MESSAGES', messages); // replace messages with ones from api
      })
    },
    resetCallFeatures({ commit }) { // call this on destroy so other users do not see previous messages
      commit('SET_CHATBOX_MESSAGES', []);
      commit('SET_CHATBOX_OPEN', false);
      commit('SET_CHATBOX_UNREAD', false);
      commit('SET_HAND_RAISED', false);
    },
  },
};
